/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  padding: 10px 40px 10px 60px;
  display: grid;
  grid-template-columns: 28vw 28vw 28vw;
  grid-row-gap: 20px;
  grid-column-gap: 20px;

  /* width: 100%; */
  margin-top: 30px;
  padding-bottom: 40px;

  @media (max-width: 1200px) {
    display: grid;
    grid-template-columns: 28vw 28vw;
  }

  button {
    background-color: rgba(0, 0, 0, 0);
    border: none;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 28vw;
  height: 277px;
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;

  div.header {
    display: flex;
    flex-direction: row;
    p {
      padding-left: 10px;
      font-size: 14px;
      color: #a1a1a1;
    }
    img {
      width: 58px;
      height: 58px;
      border-radius: 5px;
    }
  }
  div.middle {
    p.title {
      margin-bottom: 20px;
      font-size: 26px;
      color: #000;
      font-weight: bold;
    }

    p.detail {
      margin-top: 30px;
      font-size: 16px;
      color: #a1a1a1;
    }

    p.salario {
      margin-bottom: 10px;
      font-size: 18px;
      font-weight: bold;
      color: #a1a1a1;
    }
  }

  div.bottom {
    padding: 0;
    display: flex;
    flex-direction: row;
    div.tag {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 90px;
      height: 32px;
      background: #090f35;
      padding: 5px;
      border-radius: 5px;
      margin-right: 10px;
      color: #fff;
      div.circle {
        width: 14px;
        height: 14px;
        border-radius: 7px;
        background-color: #36ded6;
        margin-right: 5px;
      }
      p {
        font-size: 12px;
      }
    }
  }

  button {
    margin: 10px auto 0px;
    height: 30px;
    width: 50%;
    background: #36ded6;
    font-weight: bold;
    color: #090f35;
    border: 0;
    border-radius: 5px;
    font-size: 14px;
    transition: background 0.2s;

    &:hover {
      background: ${darken(0.08, '#36ded6')};
    }
  }
`;
